// 题库统一出口
import { DOMAINS, DEFAULT_WEIGHTS, CRITICAL_DOMAINS } from './domains.js'
import { ONLINE_INDICATORS } from './indicators.online.js'
import { FULL_INDICATORS } from './indicators.full.js'
import { EVIDENCE } from './evidence.js'
import { OPERATION_EVIDENCE_OVERRIDE, OVERRIDE_ROLE_IDS } from './evidence.operation.js'
import { PARTIES, ROLES, ROLE_MAP, ROLES_BY_PARTY } from './roles.js'
import { LEVELS, SCORE_STEPS, SCORE_STEP_LABELS, DOMAIN_ADVICE } from './levels.js'
import {
  SELF_LEVELS, SELF_LEVEL_MAP, SELF_LEVEL_LABEL, SELF_LEVEL_NODES, SPAN_MATRIX
} from './selfAssessment.js'

export {
  DOMAINS, DEFAULT_WEIGHTS, CRITICAL_DOMAINS,
  ONLINE_INDICATORS, FULL_INDICATORS,
  EVIDENCE, OPERATION_EVIDENCE_OVERRIDE, OVERRIDE_ROLE_IDS,
  PARTIES, ROLES, ROLE_MAP, ROLES_BY_PARTY,
  LEVELS, SCORE_STEPS, SCORE_STEP_LABELS, DOMAIN_ADVICE,
  SELF_LEVELS, SELF_LEVEL_MAP, SELF_LEVEL_LABEL, SELF_LEVEL_NODES, SPAN_MATRIX
}

export const EDITIONS = {
  online: { id: 'online', name: '快速评价', desc: '17 项在线指标，一次约 15 分钟', indicators: ONLINE_INDICATORS },
  full: { id: 'full', name: '完整评价', desc: '41 项能力要素，全面诊断', indicators: FULL_INDICATORS }
}

export const SCOPES = {
  project: { id: 'project', name: '项目评价', desc: '面向单一工程项目，抓执行、抓贯通、抓实效', subjectLabel: '项目名称' },
  enterprise: { id: 'enterprise', name: '企业评价', desc: '面向集团/分公司，建标准、建平台、建能力', subjectLabel: '企业名称' }
}

// 佐证材料与上传的显示开关：本期关闭（代码已就绪，后期置 true 即全量放开）
export const ENABLE_EVIDENCE = false

// 评分依据输入框的显示开关：v2.2.0 起默认关闭（自评场景无需逐条填依据，
// 避免耗时过长）。数据模型 value.note 与存储逻辑保留，后期置 true 即恢复显示
export const ENABLE_SCORE_NOTE = false

/** 取指定 级别/版本 的指标数组 */
export function getIndicators (scope, edition) {
  const pack = EDITIONS[edition] && EDITIONS[edition].indicators
  return (pack && pack[scope]) || []
}

/** 取指定 级别/版本/角色/指标 的佐证材料 */
export function getEvidence (scope, edition, roleId, indicatorId) {
  // 运营侧佐证在源文档中与建设侧重复，走人工重写覆盖表（见 evidence.operation.js）
  if (OVERRIDE_ROLE_IDS.includes(roleId)) {
    const override = OPERATION_EVIDENCE_OVERRIDE[scope]
      && OPERATION_EVIDENCE_OVERRIDE[scope][edition]
    if (override && override[indicatorId]) return override[indicatorId]
  }
  const byEdition = EVIDENCE[scope] && EVIDENCE[scope][edition]
  const byRole = byEdition && byEdition[roleId]
  return (byRole && byRole[indicatorId]) || null
}

/** 题库自检：开发期暴露于 window.__maDataCheck()，返回异常列表 */
export function validateData () {
  const errors = []
  const weightSum = DOMAINS.reduce((s, d) => s + d.weight, 0)
  if (Math.abs(weightSum - 1) > 1e-6) errors.push('权重和不为 1：' + weightSum)
  for (const scope of Object.keys(SCOPES)) {
    for (const edition of Object.keys(EDITIONS)) {
      const list = getIndicators(scope, edition)
      const expect = edition === 'online' ? 17 : 41
      if (list.length !== expect) errors.push(`${scope}/${edition} 指标数 ${list.length}，期望 ${expect}`)
      const ids = list.map((i) => i.id)
      if (new Set(ids).size !== ids.length) errors.push(`${scope}/${edition} 指标 id 重复`)
      for (const dm of DOMAINS) {
        if (!list.some((i) => i.domain === dm.id)) errors.push(`${scope}/${edition} 缺少能力域 ${dm.id}`)
      }
      for (const role of ROLES) {
        for (const ind of list) {
          if (!getEvidence(scope, edition, role.id, ind.id)) {
            errors.push(`佐证缺失 ${scope}/${edition}/${role.id}/${ind.id}`)
          }
        }
      }
      for (const ind of list) {
        if (!ind.questions || ind.questions.length === 0) errors.push(`${ind.id} 无判定问题`)
        if (!ind.levels || ind.levels.length !== 5) errors.push(`${ind.id} 评分档位不是 5 档`)
      }
    }
  }
  // 自评等级：8 个码必须都能归并到 L0-L5，且表格数据与定位图节点一一对应
  const levelSet = new Set(LEVELS.map((l) => l.level))
  for (const sl of SELF_LEVELS) {
    if (!levelSet.has(sl.mapped)) errors.push(`自评码 ${sl.code} 映射到未知等级 ${sl.mapped}`)
  }
  const nodeCodes = SELF_LEVEL_NODES.map((n) => n.code)
  for (const sl of SELF_LEVELS) {
    if (!nodeCodes.includes(sl.code)) errors.push(`自评码 ${sl.code} 缺少定位图节点`)
  }
  return errors
}
